import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const loginAction = createAsyncThunk(
  "auth/login",
  async ({ email, password }, thunkAPI) => {
    try {
      const response = await apiService.post(API_ENDPOINTS.AUTH.LOGIN, {
        email,
        password,
      });

      // Store token in localStorage
      if (response.token) {
        localStorage.setItem("authToken", response.token);
      }

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const logoutAction = createAsyncThunk(
  "auth/logout",
  async (_, thunkAPI) => {
    try {
      await apiService.post(API_ENDPOINTS.AUTH.LOGOUT);

      // Remove token from localStorage
      localStorage.removeItem("authToken");

      return {};
    } catch (error) {
      // Even if the API call fails, we should still log out locally
      localStorage.removeItem("authToken");
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const verifyTokenAction = createAsyncThunk(
  "auth/verify",
  async (_, thunkAPI) => {
    try {
      const response = await apiService.post(API_ENDPOINTS.AUTH.VERIFY);
      return response;
    } catch (error) {
      localStorage.removeItem("authToken");
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const registerAction = createAsyncThunk(
  "auth/register",
  async ({ email, password, firstName, lastName }, thunkAPI) => {
    try {
      const response = await apiService.post(API_ENDPOINTS.AUTH.REGISTER, {
        email,
        password,
        firstName,
        lastName,
      });

      if (response.token) {
        localStorage.setItem("authToken", response.token);
      }

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const forgotPasswordAction = createAsyncThunk(
  "auth/forgotPassword",
  async ({ email }, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.AUTH.FORGOT_PASSWORD,
        {
          email,
        }
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const resetPasswordAction = createAsyncThunk(
  "auth/resetPassword",
  async ({ token, password }, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.AUTH.RESET_PASSWORD,
        {
          token,
          password,
        }
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
